import { observable } from "mobx";
import { IDocumentsView } from "../Document/DocumentsView";
import { DocumentResult, SortBy } from "../DocumentReader";
import { AreaStore } from "../Stores/AppStore";

export abstract class FilesUIStore extends AreaStore implements IDocumentsView {


	/* show only Name column */
	showOnlyName = false;

	/*pagination params*/
	top: number = 50;
	skip: number = 0;
	scrollPercentage: number = 40;
	sortBy: SortBy[] = [];

	/*No Result message*/
	abstract noResultMsg: string;

	/**
	 * The api is busy
	 */
	@observable isBusy: boolean = false;

	/**
	 * The final search result.
	 */
	@observable searchResult: DocumentResult = new DocumentResult();

	/**
	 * Triggers the search
	 */
	abstract triggerSearch(resetPagination?: boolean, isScrolling?: boolean) : void;

	/**
	 * This get called when favourite state changed in DocumentList
	 * @param documentId
	 */
	public favouriteChange(documentId: string) {
		//let findItem = this.searchResult.documents.find(item => item.documentId === documentId);

		//if (findItem != null) {
		//	let index = this.searchResult.documents.indexOf(findItem);
		//	if (index > -1)
		//	{
		//		this.searchResult.documents.splice(index,1);
		//	}
		//}
	}

	abstract scrollLock: boolean;
}
